import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FieldInputModule } from '../field-input/field-input.module';
import { FieldsTemplateComponent } from './fields-template.component';

@NgModule({
    declarations: [FieldsTemplateComponent],
    imports: [CommonModule, FieldInputModule],
    exports: [FieldsTemplateComponent],
})
export class FieldsTemplateModule {}
